export default __webpack_public_path__ + "static/media/Samsung.f47ce240.png";